import { apiGet, apiPost, type ApiResult } from "./client";
import type { AuthUser, LoginResult, SchoolInfo } from "./types";

export async function login(username: string, password: string): Promise<ApiResult<LoginResult>> {
  return apiPost<LoginResult>("/auth/login", { username, password });
}

export async function logout(): Promise<ApiResult<null>> {
  return apiPost<null>("/auth/logout", undefined);
}

export async function fetchMe(): Promise<ApiResult<AuthUser>> {
  return apiGet<AuthUser>("/auth/me");
}

export async function changePassword(currentPassword: string, newPassword: string): Promise<ApiResult<null>> {
  return apiPost<null>("/auth/change-password", { currentPassword, newPassword });
}

export async function fetchSchool(): Promise<ApiResult<SchoolInfo>> {
  return apiGet<SchoolInfo>("/school");
}
